<template>
  <tabs parent="supports">
    <tab
      id="ticket_list"
      :name="translate('support.tabs.tickets')"
      :href="url+'/ticket_list'"
    >
      <TicketList

      />
    </tab>

    <tab
      id="mail_list"
      :name="translate('support.tabs.mails')"
      :href="url+'/mail_list'"
    >
      <MailList

      />
    </tab>
  </tabs>
</template>

<script>
import TicketList from "./TicketList/TicketList.vue";
import MailList from "./MailList/MailList.vue";

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Supports',
  components: {
    Tabs,
    Tab,
    TicketList,
    MailList
  },
  data () {
    return {

    }
  },

  computed: {
    url () { return '/supports' }
  },

  watch:{

  },

  created() {

  },

  methods: {

  },

}
</script>
